import React from 'react';
import { connect } from 'react-redux';
import ComboBox from '../../../../components/ComboBox';
import ReportDatePicker from '../../ReportDatePicker';
import FilterTags from '../../../../components/FilterTags';
import DateUtil from '../../../../helpers/DateUtil/DateUtil';
import caret from '../../../../assets/images/caret.svg';
import anime from 'animejs';

import './ActivityFilter.scss';

import BaseComponent from '../../../../baseClasses/BaseComponent';
import dataModel from '../../../../models/DataModel';

export class ActivityFilter extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedSubTypeId: props.selectedFilters.activitySubTypeId,
      selectedActivityId: props.selectedFilters.activityTypeId,
      startDate: props.selectedFilters.startDate,
      endDate: props.selectedFilters.endDate,
    };
    this.handleDateDisplay = this.handleDateDisplay.bind(this);

  }

  componentDidMount() {
    this.props.activityLogsDataModel.getActivitiesList();  
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.selectedFilters != this.props.selectedFilters &&
      this.props.selectedFilters
    ) {
      this.setState({
        selectedSubTypeId: this.props.selectedFilters.activitySubTypeId,
        selectedActivityId: this.props.selectedFilters.activityTypeId,
        startDate: this.props.selectedFilters.startDate,
        endDate: this.props.selectedFilters.endDate,
      });
    }
  }

  handleActivityTypeFilterRemoved(activityTypeFilters) {
    this.handleActivityChange('all', null);
  }

  handleActivityChange(type, option) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    if (type == 'all') {
      selectedFilters.activityTypeId = null;
      selectedFilters.activitySubTypeId = null;
      handleFilterChange(selectedFilters);
      this.setState({ 
        selectedActivityId: null,
        selectedSubTypeId: null, 
      });
    } else if (option) {
      if(option.activity && this.state.selectedActivity 
          && option.activity.id != this.state.selectedActivity
        ){
        this.setState({ selectedSubType: null });
      }
      this.setState({
        selectedActivityId: option.activity.id,
      });
      selectedFilters.activityTypeId = option.activity.id;
      handleFilterChange(selectedFilters);
    }
  }

  handleActivitySubTypeFilterRemoved(activitySubtypeFilters) {
    this.handleSubTypeChange('allSubtypes', null);
  }

  handleSubTypeChange(type, option) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    this.setState({ selectedSubTypeId: type });
    selectedFilters.activitySubTypeId = type == 'allSubtypes' ? null : type;
    handleFilterChange(selectedFilters);
  }

  handleDateFilterRemoved(dateFilters) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    selectedFilters.projectEventType = this.state.selectedProjectEvent;
    selectedFilters.startDate = this.state.startDate;
    selectedFilters.endDate = this.state.endDate;
    for (const dateFilter of dateFilters) {
      if (dateFilter.type == 'start') {
        selectedFilters.startDate = null;
      } else {
        selectedFilters.endDate = null; 
      }
    }
    this.setState({ startDate: selectedFilters.startDate, endDate: selectedFilters.endDate });
    handleFilterChange(selectedFilters);
  }

  handleDateSelection(date, type) {
    let { handleFilterChange, selectedFilters } = this.props;
    selectedFilters = { ...selectedFilters };
    if (type == 'start') {
      selectedFilters.startDate = date;
      this.setState({ startDate: date });
    } else {
      selectedFilters.endDate = date;
      this.setState({ endDate: date });
    }
    handleFilterChange(selectedFilters);
  }

  handleClickOutside(event) {
    if (this.reportDatePicker && !this.reportDatePicker.contains(event.target) && !event.target.className.includes('react-datepicker')) {
      this.handleDateDisplay();
    }
  }

  async handleDateDisplay() {
    let { filterActive } = this.state;
    await this.setState({ 
      datePickerLeft: this.activityFilterContainer.getBoundingClientRect().left,
      datePickerTop: this.activityFilterContainer.getBoundingClientRect().bottom,
    });
    if (!filterActive) {
      document.addEventListener('click', this.handleClickOutside, false);
      await anime({
        targets: '.ReportDatePicker',
        height: 108,
        easing: 'easeInOutCubic',
        duration: 200,
        begin: () => {
          this.setState({ filterActive: true });
        },
        update: (anim) => {
          if (anim.progress > 50) {
            this.datePicker.style.display = 'flex';
          }
        },
        complete: () => {
          document.querySelector('.ReportDatePicker').style.overflow = 'initial';
        },
      });
    }
    else {
      document.removeEventListener('click', this.handleClickOutside, false);
      await anime({
        targets: '.ReportDatePicker',
        height: 0,
        easing: 'easeInOutCubic',
        duration: 200,
        begin: () => {
          document.querySelector('.ReportDatePicker').style.overflow = 'hidden';
        },
        complete: () => {
          this.setState({ filterActive: false });
        },
        update: (anim) => {
          if (anim.progress > 50) {
            this.datePicker.style.display = 'none';
          }
        },
      });
    }
  }

  handleSetDatePickerRef(element) {
    this.datePicker = element;
  }

  createTimeDisplay() {
    let timeDisplay = '';
    if (!this.state.startDate && !this.state.endDate) {
      timeDisplay = '-- All Time --';
      return timeDisplay;
    }

    if (this.state.startDate) {
      timeDisplay += this.formatDate(this.state.startDate);
    }
    else if (!this.state.startDate) {
      timeDisplay += 'All';
    }
    if (this.state.endDate) {
      timeDisplay += ' - ' + this.formatDate(this.state.endDate);
    }
    else if (!this.state.endDate) {
      timeDisplay += ' - All';
    }

    return timeDisplay;
  }

  formatDate(date) {
    const splitDates = date.split('-');
    return `${splitDates[1]}/${splitDates[2]}/${splitDates[0]}`;
  }

  render() {
    let { selectedSubTypeId, selectedActivityId } = this.state;
    const { activitiesList } = this.props;
    let subTypeSelector, selectedActivity;
    let activityTypeFilterTags = [];
    let activitySubTypeFilterTags = [];
    if(selectedActivityId && activitiesList){
      selectedActivity = activitiesList.find(activity => activity.id == selectedActivityId);
      activityTypeFilterTags.push(selectedActivity);
      let subTypeList = [
        { type: 'allSubtypes', name: '-- All Sub-Types --' },
      ];
      selectedActivity.activity_sub_types.forEach(subType => {
        subTypeList.push({
          type: subType.id,
          name: subType.name,
          subType: subType,
        });
      });
      let currentSubTypeOption;
      
      if(selectedSubTypeId) {
        currentSubTypeOption = subTypeList.find(subType => {
          return subType.type == +selectedSubTypeId;
        });
      }
      if (!currentSubTypeOption) { 
        currentSubTypeOption = subTypeList[0];
      } else {
        activitySubTypeFilterTags.push(currentSubTypeOption);
      }
  
      subTypeSelector = (
        <ComboBox
          key={'subTypePicker'}
          id={'supTypePicker'}
          options={subTypeList}
          currentOption={currentSubTypeOption}
          hasBorder={false}
          underlined={false}
          width={286}
          height={31}
          displayFontStyle={{ fontSize: '12px' }}
          handleSelection={this.handleSubTypeChange}
        />
      );
    } else {
      subTypeSelector = 'Select an Activity';
    }

    let activityOptions = [];
    let allActivities = { type: 'all', name: '-- All Activities --' };
    let currentSelectedActivity = allActivities;

    if (activitiesList) {
      activityOptions = activitiesList.map(activity => {
        let activityOption = {
          type: activity.id,
          name: activity.name,
          activity: activity,
        };
        if (selectedActivity && activity.id == selectedActivity.id) {
          currentSelectedActivity = activityOption;
        }
        return activityOption;
      });
  
      activityOptions.splice(0, 0, allActivities);
  
      activityOptions.sort((c1, c2) => {
        if (c1.name < c2.name) {
          return -1;
        } else if (c1.name > c2.name) {
          return 1;
        } else {
          return 0;
        }
      });
    }

    let activitySelector = (
      <ComboBox
        key={'activityPicker'}    
        id={'activityPicker'}
        options={activityOptions}
        currentOption={currentSelectedActivity}
        hasBorder={false}
        underlined={false}
        height={31}
        width={286}
        menuHeight={120}
        displayFontStyle={{ fontSize: '12px' }}
        handleSelection={this.handleActivityChange}
      />
    );

    let dateFilterTags = [];
    if (this.state.startDate) {
      dateFilterTags.push({ type: 'start', name: 'FROM: ' + DateUtil.formatDateFromDash(this.state.startDate) });
    }
    if (this.state.endDate) {
      dateFilterTags.push({ type: 'end', name: 'TO: ' + DateUtil.formatDateFromDash(this.state.endDate) });
    }

    return (
      <div className="activity-log-filters">
        <div>
          <div className="activity-log-filter-selector-label">{this.textMap.activityType.toUpperCase()}</div>
          <div className="activity-log-filter-selector-container">{activitySelector}</div>
          <div className='activity-filter-selector-filtertags'>
            <FilterTags filters={activityTypeFilterTags} handleFilterRemoved={this.handleActivityTypeFilterRemoved}/>
          </div>
        </div>
        <div className='activity-sub-type-container'>
          <div className="activity-log-filter-selector-label">{this.textMap.subType.toUpperCase()}</div>
          <div className={'activity-log-filter-selector-container' + (selectedActivity ? '' : ' activity-log-filter-selector-container__inactive')}>{subTypeSelector}</div>
          <div className='activity-filter-selector-filtertags'>
            <FilterTags filters={activitySubTypeFilterTags} handleFilterRemoved={this.handleActivitySubTypeFilterRemoved}/>
          </div>
        </div>
        <div>
          <div className="activity-log-filter-selector-label">{'TIME FRAME'}</div>
          <div
            className='activity-log-filter-selector-container activity-log-filter-selector-container__time-frame'
            onClick={this.handleDateDisplay}
            ref={el => { this.activityFilterContainer = el; }}
          >
            <p className='activity-log-filter-all-time'>
              {this.createTimeDisplay()}
            </p>
            <img className='time-caret' src={caret} role="presentation"/>
          </div>
          <div className='activity-filter-selector-filtertags'>
            <FilterTags filters={dateFilterTags} handleFilterRemoved={this.handleDateFilterRemoved}/>
          </div>
        </div>
        <div ref={el => {this.reportDatePicker = el;}} >
          <ReportDatePicker 
            handleSetDatePickerRef={ this.handleSetDatePickerRef }
            handleDateSelection={ this.handleDateSelection }
            left={this.state.datePickerLeft}
            top={this.state.datePickerTop}
            startDate={this.state.startDate}
            endDate={this.state.endDate}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users.currentUser,
    activityLogsDataModel: dataModel.activityLogsDataModel,
    activitiesList: state.activityLogs.activitiesList,
  };
};

export default connect(mapStateToProps)(ActivityFilter);



// WEBPACK FOOTER //
// ./src/containers/ManagerDashboard/ActivityLog/ActivityFilter/index.js